"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const api_1 = require("../../api");
const Button_1 = __importDefault(require("../../forms/Button"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("../../forms/InputField"));
const errorNotification_1 = require("../../errorNotification");
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../../Auth/utils");
const ViewsToolPanelComponent = (props) => {
    const { user } = (0, AuthContext_1.useAuth)();
    const [views, setViews] = (0, react_1.useState)([]);
    const [selectedView, setSelectedView] = (0, react_1.useState)(null);
    const columnApi = props.columnApi;
    const viewsApi = new api_1.ViewsApi;
    const initialValues = {
        name: '',
        general: false,
    };
    (0, react_1.useEffect)(() => {
        const fetchViews = async () => {
            const data = await viewsApi.index({ grid_model: props.gridModel });
            setViews(data.views);
        };
        fetchViews();
        return () => {
            viewsApi.cancel("Cancelling in cleanup");
        };
    }, []);
    const create = async (values, { setErrors, setSubmitting }) => {
        const payload = {
            ...values,
            grid_model: props.gridModel,
            columns: columnApi.getColumnState(),
        };
        try {
            const response = await viewsApi.create(payload);
            (0, errorNotification_1.notify)('success', 'Ansicht erstellt');
            const data = await viewsApi.index({ grid_model: props.gridModel });
            setViews(data.views);
        }
        catch (error) {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
        }
    };
    const handleDeleteView = async (id) => {
        try {
            const { success } = await viewsApi.delete(id);
            if (success) {
                setViews(views => views.filter(view => view.id !== id));
            }
        }
        catch (error) {
            (0, errorNotification_1.notifyError)(error.response.data.message);
        }
    };
    const handleReset = () => {
        columnApi.resetColumnState();
        setSelectedView(null);
    };
    const loadView = (view) => {
        if (view) {
            setSelectedView(view);
            columnApi.setColumnState(view.columns);
        }
    };
    const canDeleteView = (view) => {
        if ((0, utils_1.isAllowed)(user, ['delete_view']) || view.owned_by === user?.id) {
            return true;
        }
    };
    return (react_1.default.createElement("div", { className: "p-2 flex flex-col h-full" },
        react_1.default.createElement("div", { className: 'mb-4 pb-4 border-b' },
            react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: create }, ({ isSubmitting }) => (react_1.default.createElement(formik_1.Form, null,
                react_1.default.createElement("div", { className: 'space-y-4' },
                    react_1.default.createElement(InputField_1.default, { name: "name", type: "text", label: "", placeholder: "Name der Ansicht" }),
                    (0, utils_1.isAllowed)(user, ['create_general_views']) ? (react_1.default.createElement("div", { className: "flex items-center" },
                        react_1.default.createElement(formik_1.Field, { type: "checkbox", name: "general", id: "general", className: "checkboxx" }),
                        react_1.default.createElement("label", { htmlFor: "general", className: "ml-2 block text-xs text-gray-900" }, "F\u00FCr alle verf\u00FCgbar"))) : null,
                    react_1.default.createElement(Button_1.default, { type: "submit", size: 'sm', block: true, variant: "white", disabled: isSubmitting }, "Aktuelle Ansicht speichern")))))),
        react_1.default.createElement("div", { className: "mb-4" },
            react_1.default.createElement("span", { className: "inline-block font-medium text-sm text-gray-900 mb-2" }, "Verf\u00FCgbare Ansichten"),
            views.length > 0 ? views.map((view) => (react_1.default.createElement("div", { key: view.id, className: 'flex py-1 items-center hover:text-primary-600' },
                react_1.default.createElement("input", { name: "selectedView", type: "checkbox", checked: !!(selectedView && selectedView.id === view.id), onClick: loadView.bind(this, view), readOnly: true, className: "mr-2 cursor-pointer checkboxx" }),
                react_1.default.createElement("a", { href: "#", onClick: loadView.bind(this, view), className: "text-xs flex-grow", role: "menuitem" },
                    view.name,
                    " ",
                    view.general ? '(alle)' : ''),
                (canDeleteView(view)) ? (react_1.default.createElement("div", { className: "text-gray-500 cursor-pointer", onClick: handleDeleteView.bind(this, view.id) },
                    react_1.default.createElement("svg", { className: "h-5 w-5", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                        react_1.default.createElement("path", { fillRule: "evenodd", d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z", clipRule: "evenodd" })))) : null))) : react_1.default.createElement("div", { className: "text-center text-gray-500" }, "Keine Ansichten")),
        react_1.default.createElement("div", { className: "text-right" },
            react_1.default.createElement("a", { href: "#", onClick: handleReset }, "Zur\u00FCcksetzen"))));
};
exports.default = ViewsToolPanelComponent;
